<template>
    <div
        :class="{
            'spec-item': props.pictureOrientation != 'right',
            'spec-item-right': props.pictureOrientation == 'right',
            'spec-last_item': lastItem,
        }"
    >
        <Media v-if="props.pictureOrientation != 'right'"
            default-media-type="image"
            media-classes="fit-badge"
            :media="props.image"
            :alt="props.imageAlt"
        />
        <div
            :class="
                props.pictureOrientation != 'right'
                    ? `spec-description`
                    : `spec-description-right`
            " 
            :style="textAlignClass"
        >
            <span :class="`headline-xs text-${props.headingColor}`">{{
                props.heading
            }}</span>
            <p :class="`text-${props.subtextColor}`">{{ props.subtext }}</p>
        </div>
        <Media
            v-if="props.pictureOrientation == 'right'"
            default-media-type="image"
            media-classes="fit-badge"
            :media="props.image"
            :alt="props.imageAlt"
        />
    </div>
</template>
<script lang="ts" setup>
    import { computed } from "vue";
    import Media from "@/components/Media.vue";
    import useImageOptimization from "@composables/useImageOptimization";
    let props = defineProps({
        heading: {
            type: String,
            required: false
        },
        headingColor: {
            type: String,
            default: "rothcoBlack"
        },
        subtext: {
            type: String,
            required: false
        },
        subtextColor: {
            type: String,
            default: "rothcoBlack"
        },
        image: {
            type: String,
            required: false
        },
        imageAlt: {
            type: String,
            required: false
        },
        textAlign: {
            type: String,
            required: false,
            validator: (val: string) => {
                return ["left", "center", "right", "justify"].includes(val);
            }
        },
        pictureOrientation: {
            type: String,
            required: false,
            validator: (val: string) => {
                return ["left", "right"].includes(val);
            }
        },
        lastItem: {
            type: Boolean,
            required: false
        }
    });

    let textAlignClass = computed(() => {
        return {
            textAlign: props.textAlign
        };
    });

    let { optimizedImageUrl } = useImageOptimization(props.image);
</script>

<style lang="scss" scoped>
    .fit-badge {
        width: 77px; 
        object-fit: contain;
    }
</style>
